import React from "react";
import "./Skills.css";
import useScrollReveal from "../../hooks/useScrollReveal";

const skillGroups = [
  {
    label: "PROGRAMMING",
    items: ["C", "C#", "C++", "Python", "Java", "JavaScript", "HTML/CSS", "SQL"],
  },
  {
    label: "GAME DEV & GRAPHICS",
    items: ["Unity", "Unreal Engine", "Vulkan", "OpenGL", "ShaderLab", "Three.js", "Computer Graphics"],
  },
  {
    label: "FRAMEWORKS & BACKEND",
    items: ["React", "Vue.js", "Spring Boot", "SAPUI5", ".NET Core", "REST APIs"],
  },
  {
    label: "DEVOPS & INFRA",
    items: ["Git / GitHub / GitLab", "Docker", "Jenkins", "Azure", "Kubernetes", "RabbitMQ", "Redis", "Camunda BPMN"],
  },
  {
    label: "DATABASES",
    items: ["PostgreSQL", "MySQL", "MSSQL", "Couchbase (NoSQL)"],
  },
  {
    label: "DESIGN & TOOLS",
    items: ["Figma", "Sketch", "Photoshop", "Illustrator", "Procreate", "Aseprite", "Krita", "Canva"],
  },
  {
    label: "HUMAN LANGUAGES",
    items: ["Turkish (Native)", "English — C2 Reading · C1 Listening / Writing / Speaking"],
  },
  {
    label: "SOFT SKILLS",
    items: ["Team Collaboration", "Problem-Solving", "Project Management", "Engineering Processes"],
  },
];

export default function Skills() {
  const ref = useScrollReveal();

  return (
    <section className="skills-container" ref={ref}>
      <h2 className="skills-title">Skills</h2>
      <div className="skills-monitor">
        {/* Header bar */}
        <div className="skills-header">
          <div className="skills-led" />
          <span className="skills-brand">SKILLS.SYS</span>
          <span className="skills-status">8 modules loaded</span>
        </div>

        {/* Screen */}
        <div className="skills-screen">
          <div className="skills-scanline" />
          <div className="skills-output">
            <div className="skills-line sys">guest@yalaz:~$ cat skills.txt</div>
            <div className="skills-line sys dim">---</div>
            {skillGroups.map((group, idx) => (
              <div key={idx} className="skills-block">
                <div className="skills-line label">[{group.label}]</div>
                <div className="skills-line values">
                  {group.items.map((item, i) => (
                    <span className="skills-item" key={i}>{item}</span>
                  ))}
                </div>
              </div>
            ))}
            <div className="skills-line sys dim">---</div>
            <div className="skills-line sys">EOF</div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="skills-footer">
          <span className="skills-prompt">guest@yalaz:~$</span>
          <span className="skills-cursor">_</span>
        </div>
      </div>
    </section>
  );
}
